import { render, staticRenderFns } from "./employNav.vue?vue&type=template&id=4d89941e&scoped=true&"
import script from "./employNav.vue?vue&type=script&lang=js&"
export * from "./employNav.vue?vue&type=script&lang=js&"
import style0 from "./employNav.vue?vue&type=style&index=0&id=4d89941e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d89941e",
  null
  
)

export default component.exports